import { gql } from '@src/lib/gql'

export const SYNC_ADVISOR_AGREEMENT_SIGNATURE = gql`
  mutation SyncAdvisorAgreementSignature($input: SyncAdvisorAgreementSignatureInput!) {
    syncAdvisorAgreementSignature(input: $input) {
      advisorAgreement {
        id
        advisorAgreementId
        statusKey
        signedAt
        signedStoredFileId
        documensoDocumentId
        documensoSigningUrl
        status {
          id
          key
          title
        }
        signedFile {
          id
          storedFileId
          fullUrl
          title
        }
      }
    }
  }
`
